import React from 'react';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {Grid} from '@material-ui/core'
import ImgMediaCard from './reviewCard'
import {Garlic} from '../../../assets/images/images';
import Card from './featureProCard'
import './style.scss'
import {MainHeading} from "../../index";

const responsive = {
  desktop: {
    breakpoint: {max: 3000, min: 1024},
    items: 3,
    slidesToSlide: 2 // optional, default to 1.
  },
  tablet: {
    breakpoint: {max: 1024, min: 464},
    items: 1,
    slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: {max: 464, min: 0},
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const data = [3, 3, 3, 3, 3, 3, 3, 3, 33,]

function Index1(props) {
  return (
    <div className='feature-product-container'>
      {/*<h2 className='heading-color font-18 mb-0'>Featured Product</h2>*/}
      <MainHeading title={"Featured Product"} className={'mt-0'}/>

      <p className='desc color-green font-12 text-center mb-10  p-0 mb-20'>
      An AI-Powered global marketplace that can help all the food industry players in all global situations
         </p>
      <Carousel
        swipeable={false}
        draggable={false}
        showDots={true}
        // renderButtonGroupOutside={true}
        // partialVisbile={true}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={1400}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={1600}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        // deviceType={this.props.deviceType}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px "
      >
        {(props.data || []).map((item, index) => (
          <Card index={index} item={item} key={index} onClick={(event) => props.onSellerItemClick(index, item)}/>
        ))}
      </Carousel>
    </div>
  );
}

export default Index1;
